import api from './client';
import type { XmlCteResponse, XmlCteFilters, CteExportOptions } from '../types/cte';

// CTe API para visualização de XMLs (similar ao XMLTerceiros)
class CteXmlApi {
  // Buscar XML de CTes com paginação e filtros
  async getXmlCtes(filters?: XmlCteFilters, page = 1, pageSize = 50) {
    const params = new URLSearchParams();
    
    // Parâmetros de paginação
    params.append('page', page.toString());
    params.append('pageSize', pageSize.toString());
    
    // Filtro rápido de dias
    if (filters?.dias) {
      params.append('dias', filters.dias.toString());
    }
    
    // Filtro de busca geral
    if (filters?.search) {
      params.append('search', filters.search);
    }

    // Filtros de data personalizado
    if (filters?.dataInicio) {
      params.append('dataInicio', filters.dataInicio);
    }
    
    if (filters?.dataFim) {
      params.append('dataFim', filters.dataFim);
    }

    const queryString = params.toString();
    const url = `/cte/xmls${queryString ? `?${queryString}` : ''}`;
    
    return api.get<XmlCteResponse>(url);
  }

  // Baixar XML
  async baixarXml(cteId: number) {
    const response = await api.get(`/cte/xmls/${cteId}/xml`, {
      responseType: 'blob',
    });
    
    // Criar URL para download do arquivo
    const blob = new Blob([response.data], { type: 'application/xml' });
    const url = window.URL.createObjectURL(blob);
    
    // Criar link de download
    const link = document.createElement('a');
    link.href = url;
    link.download = `CTe_${cteId}.xml`;
    document.body.appendChild(link);
    link.click();
    
    // Limpar recursos
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return response;
  }

  // Gerar e baixar DACTE PDF com Econet
  async gerarDacte(cteId: number) {
    const response = await api.get(`/cte/xmls/${cteId}/dacte-econet`, {
      responseType: 'blob',
    });
    
    // Criar URL para download do arquivo
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Criar link de download
    const link = document.createElement('a');
    link.href = url;
    link.download = `DACTE_${cteId}.pdf`;
    document.body.appendChild(link);
    link.click();
    
    // Limpar recursos
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return response;
  }

  // Exportar arquivo (genérico)
  async exportarArquivo(options: CteExportOptions) {
    return this.baixarXml(options.cteId);
  }
}

export default new CteXmlApi();